if (!customElements.get('meowkai-compare')) {
  customElements.define('meowkai-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', () => this.draw());
      this.draw();
    }
    draw() {
      const picks = [];
      const ids = new Set();
      for (const select of this.querySelectorAll('select')) {
        const option = select.selectedOptions[0];
        if (!option?.value || ids.has(option.value)) continue;
        ids.add(option.value);
        let facts = {};
        try { facts = JSON.parse(option.dataset.facts) || {}; } catch { /* Missing facts stay unknown. */ }
        picks.push({ ...option.dataset, facts });
      }
      const area = this.querySelector('.mk-compare__scroll');
      area.replaceChildren();
      this.querySelector('.mk-compare__status').textContent = picks.length < 2
        ? 'Choose at least two different products to compare.'
        : `Comparing ${picks.length} different products. Prices are for the listed package.`;
      if (picks.length < 2) return;
      const element = (tag, text) => {
        const node = document.createElement(tag);
        if (text !== undefined) node.textContent = text;
        return node;
      };
      const table = element('table');
      table.append(element('caption', 'Compare the details that affect your purchase'));
      const head = element('thead');
      const top = element('tr');
      const feature = element('th', 'Detail'); feature.scope = 'col'; top.append(feature);
      for (const p of picks) {
        const th = element('th'); th.scope = 'col';
        const link = element('a', p.title); link.href = p.url; th.append(link); top.append(th);
      }
      head.append(top); table.append(head);
      const body = element('tbody');
      const rows = [
        ['Current price', p => p.price],
        ['Availability', p => p.available === 'true' ? 'Available to order' : 'Currently unavailable'],
        ['Category', p => p.facts.category],
        ['Format / style', p => p.facts.format],
        ['Listed size / contents', p => p.facts.size],
        ['Material', p => p.facts.material],
        ['Recipe / scent', p => p.facts.recipe]
      ];
      for (const [label, get] of rows) {
        const tr = element('tr'); const th = element('th', label); th.scope = 'row'; tr.append(th);
        for (const p of picks) tr.append(element('td', get(p) || 'Not specified'));
        body.append(tr);
      }
      table.append(body); area.append(table);
    }
  });
}
